import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { AthleteEnergyExpenditureTodayOverviewQuery } from "../../../../types";
import { TDEECard } from "./TDEECard";
import { TargetDailyIntakeCard } from "./TargetDailyIntakeCard";
import { EnergyBalanceCard } from "./EnergyBalanceCard";
import { SyncStatusBadge } from "./SyncStatusBadge";

interface TodayOverviewCardsProps {
  data: NonNullable<AthleteEnergyExpenditureTodayOverviewQuery["athleteEnergyExpenditureTodayOverview"]> | null | undefined;
  athleteId: string;
  teamId: string;
  onRefresh: () => void;
  showEmptyState?: boolean;
}

export const TodayOverviewCards: React.FC<TodayOverviewCardsProps> = ({ data, athleteId, teamId, onRefresh, showEmptyState = false }) => {
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1 }}>
        <Typography variant="h3">Today's Overview</Typography>
        {data && !showEmptyState && <SyncStatusBadge lastSyncAt={new Date(data.lastSyncAt)} onRefresh={onRefresh} />}
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <TDEECard
            tdee={data?.tdee ?? undefined}
            activeEnergy={data?.activeEnergy ?? undefined}
            restingEnergy={data?.restingEnergy ?? undefined}
            source={data?.source ?? undefined}
            showEmptyState={showEmptyState}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <TargetDailyIntakeCard
            targetDailyIntake={data?.targetDailyIntake}
            mealPlanName={data?.mealPlanName}
            loggedIntake={data?.loggedIntake ?? undefined}
            showEmptyState={showEmptyState}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <EnergyBalanceCard
            energyBalance={data?.energyBalance ?? undefined}
            targetDailyIntake={data?.targetDailyIntake}
            showEmptyState={showEmptyState}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
